import { Chip } from '@mui/material';
import CloseRounded from '@mui/icons-material/CloseRounded';
import { useCurrentUser } from 'lib/contexts/ApplicationState';
import { Tag, TagType } from 'lib/types/tags';
import { modelToSlug } from 'lib/utils/modelSlugUtils';
import { userIsAdmin } from 'lib/helpers';
import { A } from 'components/A';

interface Props {
  tag: Tag;
  tagType: TagType;
  onRemove: (tag: Tag) => void;
}

export const TagChip = ({
  tag, tagType, onRemove,
}: Props) => {
  const currentUser = useCurrentUser();
  const tagValue = tag?.tagValue || tag;
  const pluralTagTypeName = tagType ? `${tagType.name}s` : 'nothing';
  const tagSlug = modelToSlug(tagValue, 'value');
  const tagHref = `/explore?${pluralTagTypeName}=${tagSlug}&creditedStatus=all`;
  const canDelete = currentUser && (
    (currentUser.id === tag?.creator?.userId) || userIsAdmin(currentUser));
  const deleteIcon = <CloseRounded />;

  return (
    <li>
      <Chip
        size="small"
        label={(
          <A
            href={tagHref}
            className="text-white font-bold"
          >
            {tagValue?.value || ''}
          </A>
        )}
        color="primary"
        {...(canDelete && { deleteIcon })}
        {...(canDelete && { onDelete: () => onRemove(tag) })}
      />
    </li>
  );
};
